import { PaintConfiguratorProps } from "@omni/types/components/props/paintConfigurator.props";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { PaintConfigurator } from "./paintConfigurator";

const PaintConfiguratorDefault = (props: PaintConfiguratorProps) => {
    const { t } = useGranite();

    return (
        <PaintConfigurator
            {...props}
            steps={[
                {
                    meta: { name: t("paintConfigurator.colorCollection") },
                    component: (props) => (
                        <PaintConfigurator.Step {...props}>
                            <PaintConfigurator.Step.Header
                                subTitle={t(
                                    "paintConfigurator.colorCollection.subTitle"
                                )}
                            />
                            <PaintConfigurator.Collections>
                                <PaintConfigurator.Collections.Collection />
                            </PaintConfigurator.Collections>
                        </PaintConfigurator.Step>
                    )
                },
                {
                    meta: { name: t("paintConfigurator.color") },
                    component: (props) => (
                        <PaintConfigurator.Step {...props}>
                            <PaintConfigurator.Step.Header
                                subTitle={t("paintConfigurator.color.subTitle")}
                            />
                            <PaintConfigurator.Colors>
                                <div
                                    className={cn(
                                        "tw:grid tw:items-start tw:gap-4",
                                        "tw:grid-cols-3",
                                        "tw:xl:grid-cols-4"
                                    )}
                                >
                                    <div
                                        className={cn(
                                            "tw:sticky tw:top-4 tw:pb-4 tw:z-1 tw:bg-background",
                                            "tw:col-span-4",
                                            "tw:lg:col-span-1 tw:lg:pb-0"
                                        )}
                                    >
                                        <PaintConfigurator.Colors.Filters>
                                            <PaintConfigurator.Colors.Filters.Collections
                                                className={cn("tw:mb-4")}
                                            />
                                            <PaintConfigurator.Colors.Filters.Families />
                                        </PaintConfigurator.Colors.Filters>
                                    </div>
                                    <div
                                        className={cn(
                                            "tw:space-y-4",
                                            "tw:col-span-4",
                                            "tw:md:col-span-4",
                                            "tw:lg:col-span-2",
                                            "tw:xl:col-span-3"
                                        )}
                                    >
                                        <PaintConfigurator.Colors.Families
                                            className={cn(
                                                "tw:grid tw:gap-2 tw:items-start",
                                                "tw:grid-cols-2",
                                                "tw:md:grid-cols-4",
                                                "tw:lg:grid-cols-3",
                                                "tw:xl:grid-cols-5"
                                            )}
                                        >
                                            <PaintConfigurator.Colors.Families.ColorList>
                                                <PaintConfigurator.Colors.Families.ColorList.Color />
                                            </PaintConfigurator.Colors.Families.ColorList>
                                        </PaintConfigurator.Colors.Families>
                                    </div>
                                </div>
                            </PaintConfigurator.Colors>
                        </PaintConfigurator.Step>
                    )
                },
                {
                    meta: { name: t("paintConfigurator.product") },
                    component: (props) => (
                        <PaintConfigurator.Step {...props}>
                            <PaintConfigurator.Step.Header
                                subTitle={t(
                                    "paintConfigurator.product.subTitle"
                                )}
                            />
                            <PaintConfigurator.Products>
                                <div
                                    className={cn(
                                        "tw:grid tw:items-start tw:gap-4",
                                        "tw:grid-cols-3",
                                        "tw:xl:grid-cols-4"
                                    )}
                                >
                                    <div
                                        className={cn(
                                            "tw:z-1 tw:bg-background tw:pb-4 tw:flex tw:flex-col tw:gap-4 tw:col-span-4 tw:sticky tw:top-4",
                                            "tw:lg:col-span-1 tw:lg:flex-col-reverse"
                                        )}
                                    >
                                        <PaintConfigurator.Products.Preview />
                                        <PaintConfigurator.Products.Filters>
                                            <PaintConfigurator.Products.Filters.Delivery
                                                className={cn(
                                                    "tw:w-full tw:mb-4 tw:pb-4 tw:border-b tw:border-b-grey-light"
                                                )}
                                            />
                                            <PaintConfigurator.Products.Filters.Volume
                                                className={cn(
                                                    "tw:w-full tw:mb-4"
                                                )}
                                            />
                                            <PaintConfigurator.Products.Filters.Finish
                                                className={cn("tw:w-full")}
                                            />
                                        </PaintConfigurator.Products.Filters>
                                    </div>
                                    <div
                                        className={cn(
                                            "tw:col-span-4",
                                            "tw:lg:col-span-2",
                                            "tw:xl:col-span-3"
                                        )}
                                    >
                                        <PaintConfigurator.Products.ProductList>
                                            <PaintConfigurator.Products.ProductList.Product />
                                        </PaintConfigurator.Products.ProductList>
                                    </div>
                                </div>
                            </PaintConfigurator.Products>
                        </PaintConfigurator.Step>
                    )
                }
            ]}
        >
            <PaintConfigurator.Navigation>
                <PaintConfigurator.Navigation.Previous />
                <PaintConfigurator.Navigation.Steps>
                    <PaintConfigurator.Navigation.Steps.StepIndicator />
                </PaintConfigurator.Navigation.Steps>
            </PaintConfigurator.Navigation>
            <PaintConfigurator.Steps />
        </PaintConfigurator>
    );
};

export { PaintConfiguratorDefault };
